<template>
  <div class="login">
    <video class="login-video" autoplay loop muted playsinline>
      <source :src="videoUrl" type="video/mp4" />
    </video>
    <div class="top-right-actions">
      <el-button class="demo-mode-btn" @click="demoLogin" icon="el-icon-view" size="small">{{ $t("演示模式") }}</el-button>
      <el-dropdown @command="i18nChange" class="user-name">
        <el-button class="demo-mode-btn" style="display: flex; align-items: center; color: #fff; cursor: pointer;"> {{ $i18n.locale == "en" ? "English" : "简体中文" }}<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
        <el-dropdown-menu slot="dropdown" style="text-align: center">
          <el-dropdown-item command="zh">简体中文</el-dropdown-item>
          <el-dropdown-item command="en">English</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div class="dl_main">
      <div class="dl_nei" v-loading="loading">
        <!-- <div class="dl_logo"></div> -->
        <div class="logo">{{ $t("智能网络自助Portal") }}</div>
        <!-- 登录表单区域 -->
        <el-form ref="loginFormRef" :model="loginForm" :rules="loginFormRules" :hide-required-asterisk="true" class="login_form">
          <!-- 用户名 -->
          <el-form-item :label="$t('账号')" prop="username">
            <el-input ref="usernameInput" v-model="loginForm.username" prefix-icon="el-icon-user-solid"></el-input>
          </el-form-item>
          <!-- 密码 -->
          <el-form-item :label="$t('密码')" prop="password">
            <el-input ref="passwordInput" v-model="loginForm.password" prefix-icon="el-icon-lock" type="password" @keyup.enter.native="login" show-password></el-input>
          </el-form-item>
          <template v-if="needEmailVerify">
            <div class="email-verify-tip">
              {{ $t("验证码将发送至") }}：{{ emailMasked }}
            </div>
            <el-form-item :label="$t('邮箱验证码')" prop="emailCode">
              <div class="email-code-row">
                <el-input v-model="emailCode" :placeholder="$t('请输入邮箱验证码')" maxlength="6" @keyup.enter.native="login"></el-input>
                <el-button class="send-code-btn" :disabled="sendCodeCountdown > 0 || sendCodeLoading" :loading="sendCodeLoading" @click="sendEmailCode">
                  {{ sendCodeCountdown > 0 ? `${sendCodeCountdown}s` : $t("获取验证码") }}
                </el-button>
              </div>
            </el-form-item>
          </template>
        </el-form>
        <div class="login-options">
          <el-checkbox class="remember" v-model="isremember">{{ $t("记住用户名及密码") }}</el-checkbox>
          <el-tooltip
            :content="$t('如忘记密码，请联系客服：400-6228-986转2 或通过其他方式联系管理员')"
            placement="top"
            effect="dark"
            :open-delay="300"
          >
            <div class="forgot-password">{{ $t("忘记密码") }}</div>
          </el-tooltip>
        </div>
        <div>
          <el-button class="login-btn" type="primary" @click="login">{{ $t("登 录") }}</el-button>
        </div>
      </div>
    </div>
    <div class="dl_bottom">{{ $t("浏览器推荐使用Chrome 73及其以上版本，推荐分辨率为1920x1080,最小支持分辨率为1366x768") }}.</div>
    <div class="overlay" v-if="isSelect" style="display: flex; justify-content: center; align-items: center">
      <div class="productdialog">
        <el-header>
          <!-- <i class="el-icon-close" style="float: right; color: #409eff; font-size: 2em; float: right; cursor: pointer; margin: 14px" @click="isSelect = false"></i> -->
        </el-header>
        <div class="select-dialog">
          <div class="select-title">{{ $t("请选择您要查看的产品，点击进入") }}</div>
          <div class="select-content">
            <!-- :style="{ 'background-image': url(../assets/img/productbg1.jpg), opacity: item.opacity }" -->
            <span class="img" v-for="(item, index) in systemOps" :key="index" :style="{ 'background-image': `url(${require(`@/assets/img/productbg${index + 1}.png`)})`, opacity: 1 }" @click="selectProduct(item.value, item.name)">
              <div>{{ $t(item.name) }}</div>
              <!-- <el-button type="primary" style="margin-top: 8em; width: 70%" @click="changeProduct(item.value, item.name)">点击进入</el-button> -->
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { removeToken, saveToken, getToken } from "@/utils/token";
import store from "@/store";
import { setCookies, getCookies, clearCookies } from "../utils/cookies";
import { checkAndSetDemoMode } from "@/api/request";
import { encryptLoginPassword } from "@/utils/loginPassword";

export default {
  data() {
    return {
      bgUrl: require(`../assets/img/bg_10_${this.$i18n.locale}.png`),
      videoUrl: require(`../assets/img/newlogin.mp4`),
      isSelect: false,
      loading: false,
      // 是否记住密码
      isremember: false,
      // 登录表单的数据绑定对象
      loginForm: {
        username: "",
        password: "",
      },
      // 表单的验证规则对象
      loginFormRules: {
        // 验证用户名是否合法
        username: [{ required: true, message: this.$t("请输入账号"), trigger: "blur" }],
        // 验证密码是否合法
        password: [{ required: true, message: this.$t("请输入密码"), trigger: "blur" }],
      },
      token: "",
      // 演示模式配置
      demoConfig: {
        username: "608021b",
        password: "608021b@zxc",
        productTag: "FASTSDWANGUARD", // 如果为null则自动选择第一个产品
        productName: "安全定向SD-WAN", // 如果为null则自动选择第一个产品
      },
      systemOps: [],
      isDemoMode: false, // 标识是否为演示模式
      needEmailVerify: false,
      emailMasked: "",
      emailCode: "",
      sendCodeLoading: false,
      sendCodeCountdown: 0,
      sendCodeTimer: null,
    };
  },
  watch: {
    "loginForm.username"() {
      this.resetEmailVerifyState();
    },
    "loginForm.password"() {
      this.resetEmailVerifyState();
    },
  },
  beforeDestroy() {
    if (this.sendCodeTimer) {
      clearInterval(this.sendCodeTimer);
    }
  },
  created() {
    const token = getToken();
    if (token) {
      this.$backend.login.logout().catch(() => {});
      removeToken(sessionStorage.getItem("username"));
    }
    if (sessionStorage.getItem(`isremember`) === "true") {
      let form = getCookies();
      // 将账号密码付给form
      this.loginForm.username = form[0];
      this.loginForm.password = form[1];
      this.isremember = true;
    }
  },
  methods: {
    resetEmailVerifyState() {
      this.needEmailVerify = false;
      this.emailMasked = "";
      this.emailCode = "";
    },
    buildLoginPayload() {
      const payload = {
        username: this.loginForm.username,
        password: encryptLoginPassword(this.loginForm.password),
      };
      if (this.needEmailVerify && this.emailCode) {
        payload.email_code = this.emailCode;
      }
      return payload;
    },
    startSendCodeCountdown(seconds = 60) {
      this.sendCodeCountdown = seconds;
      if (this.sendCodeTimer) {
        clearInterval(this.sendCodeTimer);
      }
      this.sendCodeTimer = setInterval(() => {
        if (this.sendCodeCountdown <= 1) {
          this.sendCodeCountdown = 0;
          clearInterval(this.sendCodeTimer);
          this.sendCodeTimer = null;
        } else {
          this.sendCodeCountdown -= 1;
        }
      }, 1000);
    },
    async sendEmailCode() {
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) return;
        this.sendCodeLoading = true;
        try {
          const res = await this.$backend.login.sendEmailCode({
            username: this.loginForm.username,
            password: encryptLoginPassword(this.loginForm.password),
          });
          if (res.data && !res.data.error) {
            this.needEmailVerify = true;
            this.emailMasked = res.data.email_masked || this.emailMasked;
            this.$notify({ title: res.data.msg || this.$t("验证码已发送"), type: "success" });
            this.startSendCodeCountdown(60);
          }
        } catch (error) {
          this.$notify({
            title: this.$t("发送失败"),
            message: error.response && error.response.data ? error.response.data.msg : this.$t("验证码发送失败"),
            type: "error",
          });
        } finally {
          this.sendCodeLoading = false;
        }
      });
    },
    async completeLoginAfterToken(tokenRes) {
      if (tokenRes.status == 200) {
        this.token = tokenRes.data.token;
      }
      let userRes = await this.$axios
        .get(`/api/user/?username=${this.loginForm.username}`, {
          headers: { Authorization: `Bearer ${this.token}` },
        })
        .then((res) => res);
      if (userRes.status == 200) {
        let user = userRes.data.results ? userRes.data.results[0] : userRes.data[0];
        if (user) {
          saveToken(user.username, this.token);
        } else {
          this.loading = false;
          this.$notify({ title: this.$t("登录失败"), message: "账号未关联，请联系管理员关联账户", type: "error" });
          return;
        }
        sessionStorage.setItem("username", user.username);
        let userinfo = JSON.stringify({ ...user, is_change: tokenRes.data["is_change"] });
        sessionStorage.setItem("userinfo", userinfo);
        this.checkAndSetDemoModeForLogin(user.username);
      }
      let permissionRes = await this.$store.dispatch("getPermission").then((res) => res);
      sessionStorage.setItem("permission", JSON.stringify(permissionRes));
      this.$store.commit("set_Permission", permissionRes);
      let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
      if (userinfo.is_web) {
        this.$backend.product.tenantGet().then((res) => {
          this.systemOps = res.data.data.map((el) => {
            return {
              name: el.name,
              value: el.tag,
              img: "",
            };
          });
          if (this.isDemoMode) {
            if (this.systemOps.length > 0) {
              let selectedProduct = null;
              if (this.demoConfig.productTag) {
                selectedProduct = this.systemOps.find((item) => item.value === this.demoConfig.productTag);
              }
              if (!selectedProduct) {
                selectedProduct = this.systemOps[0];
              }
              this.selectProduct(selectedProduct.value, selectedProduct.name);
            } else {
              this.$notify({ duration: 3000, title: this.$t("登录成功"), type: "success" });
              this.$router.push("/home");
              this.loading = false;
            }
          } else if (this.systemOps.length == 1) {
            this.selectProduct(this.systemOps[0].value, this.systemOps[0].name);
          } else {
            this.isSelect = true;
            this.loading = false;
          }
        });
      } else {
        this.$notify({ duration: 3000, title: this.$t("登录成功"), type: "success" });
        this.$router.push("/home");
        this.loading = false;
      }
    },
    async requestLoginToken() {
      const tokenRes = await this.$backend.login.login(this.buildLoginPayload()).then((res) => res);
      if (tokenRes.data && tokenRes.data.require_email_verify) {
        this.needEmailVerify = true;
        this.emailMasked = tokenRes.data.email_masked || "";
        this.loading = false;
        this.$notify({ title: tokenRes.data.msg || this.$t("请输入邮箱验证码"), type: "info" });
        return null;
      }
      if (tokenRes.data && tokenRes.data.error) {
        throw { response: { data: tokenRes.data } };
      }
      return tokenRes;
    },
    i18nChange(val) {
      if (this.$i18n.locale == val) {
        return;
      } else {
        localStorage.setItem("lang", val);
        this.$i18n.locale = val;
        setTimeout(() => {
          window.location.reload(); //后端的只能通过刷新才能获取新的语言
        }, 100);
      }
    },
    // 检查并设置演示模式
    checkAndSetDemoModeForLogin(username) {
      // 设置 username 到 sessionStorage（如果还没有）
      if (!sessionStorage.getItem("username")) {
        sessionStorage.setItem("username", username);
      }
      // 调用 request.js 中的函数来检查并设置演示模式
      checkAndSetDemoMode();
    },
    selectProduct(type, name) {
      this.isSelect = false;
      store.commit("set_systemType", { type: type, name: name });
      sessionStorage.setItem(`systemType`, type);
      sessionStorage.setItem(`systemName`, name);
      this.$notify({ duration: 3000, title: this.$t("登录成功"), type: "success" });
      this.$router.push("/home");
      this.loading = false;
      // sessionStorage.setItem("systemType", type);
    },

    // 演示模式登录
    async demoLogin() {
      // 设置演示模式标识，禁用浏览器自动保存密码
      this.isDemoMode = true;
      
      // 自动填充演示账号密码
      this.loginForm.username = this.demoConfig.username;
      this.loginForm.password = this.demoConfig.password;

      // 禁用浏览器自动保存密码功能
      this.$nextTick(() => {
        // 设置表单的 autocomplete 属性
        const form = this.$refs.loginFormRef.$el;
        if (form) {
          form.setAttribute('autocomplete', 'off');
        }
        // 设置用户名输入框的 autocomplete 属性
        if (this.$refs.usernameInput && this.$refs.usernameInput.$el) {
          const usernameInput = this.$refs.usernameInput.$el.querySelector('input');
          if (usernameInput) {
            usernameInput.setAttribute('autocomplete', 'off');
          }
        }
        // 设置密码输入框的 autocomplete 属性为 new-password，这会阻止浏览器保存密码
        if (this.$refs.passwordInput && this.$refs.passwordInput.$el) {
          const passwordInput = this.$refs.passwordInput.$el.querySelector('input');
          if (passwordInput) {
            passwordInput.setAttribute('autocomplete', 'new-password');
          }
        }
      });

      // 执行登录
      this.loading = true;
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) {
          this.loading = false;
          return;
        }

        // 演示模式不记住密码
        clearCookies();
        sessionStorage.setItem("isremember", false);

        try {
          const tokenRes = await this.requestLoginToken();
          if (!tokenRes) return;
          await this.completeLoginAfterToken(tokenRes);
        } catch (error) {
          console.log("error.response", error.response);
          this.loading = false;
          if (error.response && error.response.data && error.response.data.is_active == false) {
            this.$notify({ title: this.$t("登录失败"), message: "账号已被冻结", type: "error" });
          } else {
            this.$notify({
              title: this.$t("登录失败"),
              message: error.response && error.response.data ? error.response.data.msg : "演示账号登录失败，请检查配置",
              type: "error",
            });
          }
        }
      });
    },

    login() {
      // 普通登录时，重置演示模式标识
      this.isDemoMode = false;
      
      this.loading = true;
      this.$refs.loginFormRef.validate(async (valid) => {
        if (!valid) {
          this.loading = false;
          return;
        }
        if (this.isremember) {
          // 判断 如果勾选记住密码
          setCookies(this.loginForm.username, this.loginForm.password, 7);
        } else {
          // 否则 清空cookies
          clearCookies();
        }
        sessionStorage.setItem("isremember", this.isremember);
        if (this.needEmailVerify && !this.emailCode) {
          this.loading = false;
          this.$notify({ title: this.$t("请输入邮箱验证码"), type: "warning" });
          return;
        }
        try {
          const tokenRes = await this.requestLoginToken();
          if (!tokenRes) return;
          await this.completeLoginAfterToken(tokenRes);
        } catch (error) {
          console.log("error.response", error.response);
          this.loading = false;
          if (error.response && error.response.data && error.response.data.is_active == false) {
            this.$notify({ title: this.$t("登录失败"), message: "账号已被冻结", type: "error" });
          } else {
            this.$notify({
              title: this.$t("登录失败"),
              message: error.response && error.response.data ? error.response.data.msg : this.$t("登录失败"),
              type: "error",
            });
          }
        }
      });
    },
  },
};
</script>

<style scoped>
::v-deep .el-icon-user-solid:before {
  font-size: 18px;
}
::v-deep .el-icon-lock:before {
  font-size: 18px;
}
::v-deep .el-input__inner {
  height: 44px;
  border-top-width: 0px;
	border-left-width: 0px;
	border-right-width: 0px;
	border-bottom-width: 1px;
}
::v-deep .el-input--prefix .el-input__inner {
  padding-left: 34px;
}
::v-deep .login_form .el-form-item__label {
  color: #fff;
  font-size: 14px;
}
::v-deep .login_form .el-input__inner {
  height: 44px !important;
  background: transparent !important;
  background-color: transparent !important;
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5) !important;
  border-radius: 0 !important;
  color: #fff !important;
  caret-color: #fff !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 8px !important;
  padding-top: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}
::v-deep .login_form .el-input--prefix .el-input__inner {
  padding-left: 34px !important;
}
::v-deep .login_form .el-input__inner::placeholder {
  color: rgba(255, 255, 255, 0.6) !important;
}
::v-deep .login_form .el-input__inner:focus {
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.9) !important;
  background: transparent !important;
  background-color: transparent !important;
  box-shadow: none !important;
  outline: none !important;
  caret-color: #fff !important;
}
::v-deep .login_form .el-input__inner:hover {
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.7) !important;
}
/* 覆盖浏览器自动填充样式 */
::v-deep .login_form .el-input__inner:-webkit-autofill,
::v-deep .login_form .el-input__inner:-webkit-autofill:hover,
::v-deep .login_form .el-input__inner:-webkit-autofill:focus,
::v-deep .login_form .el-input__inner:-internal-autofill-selected {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5) !important;
  -webkit-text-fill-color: #fff !important;
  color: #fff !important;
  box-shadow: 0 0 0 1000px transparent inset !important;
  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
  transition: background-color 5000s ease-in-out 0s !important;
}
::v-deep .login_form .el-input__inner:-webkit-autofill:focus {
  border-bottom: 1px solid rgba(255, 255, 255, 0.9) !important;
}
::v-deep .login_form .el-icon-user-solid:before,
::v-deep .login_form .el-icon-lock:before {
  color: rgba(255, 255, 255, 0.7);
}
.login {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}
.login-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
}
.dl_bg {
  float: left;
  width: 100%;
  text-align: center;
  height: 100vh;
  overflow: hidden;
}
.dl_bg img {
  height: 100vh;
  width: 100%;

  object-fit: cover;
}
.dl_bottom {
  position: absolute;
  left: 50%;
  bottom: 1%;
  transform: translateX(-50%);
  width: 34vw;
  z-index: 11;
  font-size: 13px;
  color: #708090;
  white-space: nowrap;
}
.dl_main {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 5%;
  width: 32vw;
  z-index: 11;
  justify-content: center;
  align-items: center;
  display: -webkit-flex;
}
.dl_nei {
  display: inline-block;
  width: 100%;
  background: rgba(30, 40, 60, 0.4);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  overflow: hidden;
  padding: 7.2vh 3.5vw;
  padding-bottom: 3.1vh;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
}
.logo {
  font-weight: bolder;
  color: #fff;
  font-size: 36px;
  margin-bottom: 1em;
}
.dl_logo {
  text-align: center;
  float: left;
  width: 100%;
  padding-bottom: 70px;
  background: url(../assets/img/login-logo.png) -150px 0 no-repeat;
}
.dl_logo img {
  max-width: 100%;
}
.dl_one {
  float: left;
  width: 100%;
}
.dl_one li {
  float: left;
  width: 100%;
  margin-bottom: 30px;
  line-height: 40px;
}
.dl_one li .accountInput {
  border: 1px solid #bfbfbf;
  float: left;
  width: 100%;
  height: 44px;
  line-height: 42px;
  border-radius: 4px;
  padding-left: 40px;
}
#account {
  background: url(../assets/img/bg_11.png) no-repeat 13px center;
}
#txt_pwd {
  background: url(../assets/img/bg_12.png) no-repeat 13px center;
}
::v-deep .remember {
  color: #fff;
  margin: 0;
}
::v-deep .remember span {
  font-size: 12px;
  color: #fff;
}
::v-deep .remember .el-checkbox__label {
  color: #fff;
}
::v-deep .remember .el-checkbox__input .el-checkbox__inner {
  width: 16px;
  height: 16px;
}
::v-deep .el-checkbox__inner::after {
  width: 5px;
  height: 9px;
}
.login-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 5px;
  margin-bottom: 20px;
}
.forgot-password {
  color: #BBBBBB;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s;
}
.forgot-password:hover {
  color: #66b1ff;
  text-decoration: underline;
}
.top-right-actions {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  z-index: 12;
}
.demo-mode-btn {
  background: linear-gradient(135deg, rgba(64, 158, 255, 0.9) 0%, rgba(64, 158, 255, 0.7) 100%);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: #fff !important;
  font-weight: 500;
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
}
.demo-mode-btn:hover {
  background: linear-gradient(135deg, rgba(64, 158, 255, 1) 0%, rgba(64, 158, 255, 0.9) 100%);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.5);
  transform: translateY(-2px);
  border-color: rgba(255, 255, 255, 0.5);
}
.demo-mode-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 6px rgba(64, 158, 255, 0.4);
}
.demo-mode-btn i {
  margin-right: 5px;
  font-size: 16px;
}
.a {
  float: right;
  color: #0189fa;
  font-size: 16px;
}
.dl_one .btn {
  float: left;
  width: 100%;
  height: 50px;
  background: #0189fb;
  font-size: 18px;
  border-radius: 5px;
  color: #fff;
}
.dl_one .li {
  margin-bottom: 15px;
  margin-top: 5px;
}
.appDownload {
  text-align: center;
  margin-bottom: 30px;
  padding-top: 20px;
}
.appDownload img {
  margin: 0px 10px;
}
.login-btn {
  width: 100%;
  height: 50px;
  font-size: 16px;
  margin-bottom: 20px;
}
.email-verify-tip {
  color: rgba(255, 255, 255, 0.85);
  font-size: 12px;
  margin-bottom: 8px;
}
.email-code-row {
  display: flex;
  gap: 10px;
  align-items: center;
}
.email-code-row .el-input {
  flex: 1;
}
.send-code-btn {
  flex-shrink: 0;
  white-space: nowrap;
}
.demo-btn {
  width: 100%;
  height: 50px;
  font-size: 18px;
  margin-bottom: 20px;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(127, 127, 127, 0.5); /* 这里的最后一个参数控制透明度，0表示完全透明，1表示完全不透明 */
  z-index: 999; /* 确保遮罩层在最上层 */
}
.productdialog {
  border-radius: 10px;
  height: 70%;
  width: 85%;
  /* background-color: #f0ffff; */
  background: url(../assets/img/headerbg.png) no-repeat;
}
.select-dialog {
  height: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333333;
}
.select-title {
  font-weight: bolder;
  font-size: 2em;
}
.select-content {
  height: 100%;
  margin-top: 2em;
  width: 100%;
  display: flex;
  justify-content: space-around;
}
.select-content .img {
  cursor: pointer;
  display: flex;
  margin: 0 12px;
  font-size: 2em;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  width: 260px;
  /* height: 286px; */
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}
.select-content .img div {
  margin: 1em;
  font-size: 20px;
  font-weight: bold;
}
</style>
<style>
/* 非 scoped 样式，覆盖浏览器自动填充样式 */
.login_form .el-input__inner:-webkit-autofill,
.login_form .el-input__inner:-webkit-autofill:hover,
.login_form .el-input__inner:-webkit-autofill:focus,
.login_form .el-input__inner:-internal-autofill-selected {
  background: transparent !important;
  background-color: transparent !important;
  background-image: none !important;
  border: none !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.5) !important;
  -webkit-text-fill-color: #fff !important;
  color: #fff !important;
  caret-color: #fff !important;
  box-shadow: 0 0 0 1000px transparent inset !important;
  -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
  transition: background-color 5000s ease-in-out 0s !important;
}
.login_form .el-input__inner:-webkit-autofill:focus {
  border-bottom: 1px solid rgba(255, 255, 255, 0.9) !important;
  caret-color: #fff !important;
}
</style>